var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.224 24h-6.5l-1.24 3h-3.32l6.24-14h3.2l6.26 14h-3.4l-1.24-3zm-1.02-2.46l-2.22-5.36-2.22 5.36h4.44z",
    fill: "var(--iconColorPrimary, #235CEE)"
  })));
}
export default SvgFreeText;